module.exports = __webpack_public_path__ + "img/jhaixiu.70ad32ec.gif";